import { EFinancingCompany } from '@if/core/types'
import { useIfUser } from '@if/mui'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { saveLastCompany, useCompanySwitchPath, useCurrentCompany, useUrlCompany } from '@src/services/company-hooks'
import { useNavigate } from 'react-router-dom'

/**
 * Whether the selector has anything to offer. Exported because the app bar's `endSlot`
 * renders a leading divider around whatever it is given — an empty selector would leave
 * that divider hanging on its own.
 */
export const useHasCompanyChoice = (): boolean => {
  const { companyIds } = useIfUser()

  return companyIds.length > 1
}

const CompanySelector = () => {
  const user = useIfUser()
  const selectedCompany = useCurrentCompany()
  const urlCompany = useUrlCompany()
  const getCompanySwitchPath = useCompanySwitchPath()
  const navigate = useNavigate()
  const availableCompanies = user.companyIds
  const showCompanySelector = useHasCompanyChoice()

  const handleChange = (event: SelectChangeEvent<EFinancingCompany>) => {
    const company = event.target.value as EFinancingCompany
    saveLastCompany(company)
    // Without a company in the URL, the screen does not change: only the nav's links follow the new company.
    if (!urlCompany) return
    const companySwitchPath = getCompanySwitchPath(company)
    navigate(companySwitchPath)
  }

  if (!showCompanySelector || availableCompanies.length === 0) {
    return null
  }

  return (
    <Select fullWidth={false} size="small" value={selectedCompany ?? ''} onChange={handleChange}>
      {availableCompanies.map((company) => (
        <MenuItem key={company} value={company}>
          {company}
        </MenuItem>
      ))}
    </Select>
  )
}

export default CompanySelector
